import InstallContainer from "./InstallContainer";

export default InstallContainer;
